// @ts-strict-ignore
import update from 'immutability-helper'
import { uniq } from 'lodash'
import { createAction } from 'redux-actions'
import storage from 'services/localStorage'
import { ActionWithPayload } from 'types/redux'

export const CLOSE_SNACKBAR = 'flexhire/client/DASHBOARD_CLOSE_SNACKBAR'
export const RESET_CLOSED_SNACKBAR = 'flexhire/client/DASHBOARD_RESET_SNACKBARS'

const closedSnackbarsLocation = 'flexhire-client-dashboard-closed-snackbars'

export const closeSnackbar = createAction(CLOSE_SNACKBAR) as ({ name }: { name: string }) => ActionWithPayload<typeof CLOSE_SNACKBAR, { name: string }>
export const resetSnackbar = createAction(RESET_CLOSED_SNACKBAR) as ({ name }: { name: string }) => ActionWithPayload<typeof RESET_CLOSED_SNACKBAR, { name: string }>

function saveClosedSnackbars(list: string[]) {
  storage.setItem(closedSnackbarsLocation, JSON.stringify(list))
}

export function loadClosedSnackbars(): string[] {
  try {
    let closedSnackbarsString = storage.getItem(closedSnackbarsLocation)
    return (closedSnackbarsString ? JSON.parse(closedSnackbarsString) : []) || []
  } catch (error) {
    console.warn(error)
    return []
  }
}

function getInitialState() {
  return {
    closedSnackbars: null as string[],
  }
}

type ActionType = ReturnType<
  typeof closeSnackbar | typeof resetSnackbar
>

export default function clientDashboardReducer(state = getInitialState(), { type, payload }: ActionType) {
  switch (type) {
    case CLOSE_SNACKBAR: {
      const newList = uniq((state.closedSnackbars || []).concat([payload.name]).filter(x => typeof x === 'string'))
      saveClosedSnackbars(newList)
      return update(state, { closedSnackbars: { $set: newList } })
    }

    case RESET_CLOSED_SNACKBAR: {
      const newList = (state.closedSnackbars || []).filter(snackbar => snackbar !== payload.name)
      saveClosedSnackbars(newList)
      return update(state, { closedSnackbars: { $set: newList } })
    }

    default:
      return state
  }
}
